import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

const Experience = ({ isDarkMode }) => {
    // Throw an error if isDarkMode prop isn't provided
    if (isDarkMode === undefined) {
        throw new Error('isDarkMode prop is required for Experience component');
    }

    const [experienceData, setExperienceData] = useState([]);

    useEffect(() => {
        fetch('/data/experience.json')
            .then(response => response.json())
            .then(data => {
                // Sort by ID descending and take top 3
                const sortedData = [...data].sort((a, b) => b.id - a.id).slice(0, 3);
                setExperienceData(sortedData);
            })
            .catch(error => console.error('Error fetching experience data:', error));
    }, []);

    const scrollToSkills = () => {
        const skillsSection = document.getElementById('skills');
        if (skillsSection) {
            skillsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="mainArea transition-effect" id="experience">
            <div className="experience transition-effect">
                <div className="leftArea">
                    <img
                        src="/images/siteElements/professional/sa4s.png"
                        alt="Experience Top"
                        className="topImg"
                    />

                    <div className="contentArea">
                        <div className="leftContent">
                            <div className="sectionTitle">
                                Experience
                            </div>

                            <img
                                src="/images/siteElements/scroll-down.png"
                                alt="Scroll Down Indicator"
                                className="expScrollDown"
                                onClick={scrollToSkills}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                        <div className="rightContent">
                            {experienceData.map((exp, index) => (
                                <div className="experienceItem" key={index}>
                                    <p className="expTitle">
                                        {exp.title}
                                        <span className="expPeriod">{exp.period}</span>
                                    </p>
                                    <p className="expLocation">{exp.location}</p>
                                    <p className="expDesc">
                                        {exp.description}
                                    </p>
                                    <div className="expTechList">
                                        {exp.technologies.map((tech, techIndex) => (
                                            <span className="expTechItem" key={techIndex}>{tech}</span>
                                        ))}
                                    </div>
                                </div>
                            ))}

                            <div className="expViewMoreContainer">
                                <Link to="/experience" className="expViewMoreLink">
                                    View More <i className="fa-solid fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rightArea">
                    <img
                        src="/images/siteElements/professional/thub.jpg"
                        alt="Experience Right"
                        className="rightImg"
                    />
                </div>
            </div>
        </div>
    );
};

export default Experience;